import { HelpTooltipHTML } from "../../../../utils/tooltip";
import * as React from "react";
import { ReactNode, useCallback } from "react";
import IJobSection from "../../interfaces/IJobSection";
import classNames from "classnames";
import { useResultsContext } from "../../context/results-context";

interface Props {
  section: IJobSection,
  className?: string,
  children?: ReactNode,
}

export function BoxHeader({section, children, className}: Props) {

  const {
    selectSection,
    selectedSections,
  } = useResultsContext();

  const handleChange = useCallback((ev) => {
    selectSection(ev.target.dataset.id, ev.target.checked);
  }, [selectSection])

  if (!section.tooltipHTML && section.tooltipHTML !== false) {
    // If tooltip is false, it means we don't want any tooltip for the section.
    console.warn(`No tooltip for section ${section.name} (${section.id})`)
  }

  const selected = selectedSections[section.id] ?? false;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '5px',
    }} className={classNames('ll-section-header', className)}>
      <input
        type="checkbox"
        className="ll-section-enable"
        checked={selected}
        disabled={section.disabled || section.loading}
        data-id={section.id}
        onChange={handleChange}
      />
      <div className="ll-section-name" style={{
        fontSize: '1.2rem',
        flex: '1',
      }}>
        <span>{section.name}</span>
        {section.tooltipHTML ? <HelpTooltipHTML>{section.tooltipHTML}</HelpTooltipHTML> : null}
      </div>
      <div className="ll-show-label-row">
        {children}
      </div>
    </div>
  );
}